/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ w: NonNullable<unknown> }} Water_Ecs_ConsumptionInputs */



/**
* | output |
* | --- |
* | "Cold water used for domestic hot water: {w} m³" |
*
* @param {Water_Ecs_ConsumptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const water_ecs_consumption = /** @type {((inputs: Water_Ecs_ConsumptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Water_Ecs_ConsumptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Cold water used for domestic hot water: ${i?.w} m³`)
	return /** @type {LocalizedString} */ (`Eau froide utilisée par l'eau chaude sanitaire : ${i?.w} m³`)
});